import { createRootRoute, Outlet } from '@tanstack/react-router'
import { QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { ErrorBoundary } from '@sentry/react'
import { queryClient } from '@/lib/query-client'
import { Toaster } from '@/components/ui/sonner'
import { Button } from '@/components/ui/button'

// TODO(post-design-loop): restyle fallback
function ErrorFallback() {
  return (
    <div className="flex min-h-screen items-center justify-center">
      <div className="space-y-4 text-center">
        <p className="text-sm text-muted-foreground">
          Something broke on our side — reload to continue
        </p>
        <Button onClick={() => window.location.reload()}>Reload</Button>
      </div>
    </div>
  )
}

function RootComponent() {
  return (
    <QueryClientProvider client={queryClient}>
      <ErrorBoundary fallback={<ErrorFallback />}>
        <Outlet />
      </ErrorBoundary>
      <Toaster richColors position="top-right" />
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  )
}

export const Route = createRootRoute({ component: RootComponent })
